<template>
  <div class="tabs-box" ref="tabsBox">
    <div class="active-indicator" :style="activeIndicatorStyle"></div>
    <div @click="change(item, index)" ref="tabItems"
      :class="['tabs-item', computedValue === item.key ? 'tabs-item-active' : '']" v-for="item, index in list"
      :key="index">
      {{ item.label }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed } from 'vue'

// 通过 ref 获取元素
const tabsBox = ref(null)
const tabItems = ref([]) // 用于存储所有 tab-item 的引用
const activeIndicatorStyle = ref({})


const props = defineProps({
  list: {
    type: Array,
    default: []
  },
  modelValue: String, // 传入的值，父组件通过 v-model 绑定
})

const emit = defineEmits(['update:modelValue', 'change'])

// 通过 computed 实现双向绑定
const computedValue = computed({
  get() {
    return props.modelValue // 获取传入的值
  },
  set(newValue) {
    emit('update:modelValue', newValue) // 触发更新父组件的值
    emit('change', newValue) // 触发更新父组件的值
  }
})


// 在组件挂载时设置初始状态
onMounted(() => {
  moveIndicator(0) // 默认激活第一个选项
})


function change(item, index) {
  computedValue.value = item.key
  moveIndicator(index)
}

// 移动指示器
function moveIndicator(index) {
  nextTick(() => {
    const selectedItem = tabItems.value[index]
    if (selectedItem) {
      const offsetLeft = selectedItem.offsetLeft
      const width = selectedItem.offsetWidth
      activeIndicatorStyle.value = {
        transform: `translateX(${offsetLeft}px)`,
        width: `${width - 2}px`
      }
    }
  })
}

</script>

<style lang="scss" scoped>
.tabs-box {
  position: relative;
  display: inline-flex;
  height: 38px;
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #DADADE;
  padding: 3px 2px;
  // overflow: hidden; // 防止溢出

  .tabs-item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 13px;
    line-height: 13px;
    color: #6C6F75;
    padding: 0 20px;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    z-index: 1; // 确保内容在指示器之上
  }

  .tabs-item:hover {
    font-weight: 600;
  }

  .tabs-item-active {
    font-weight: 600;
    color: #fff;
  }

  .active-indicator {
    position: absolute;
    height: 30px;
    background-color: var(--el-color-primary);
    border-radius: 8px;
    transition: transform 0.3s ease, width 0.3s ease;
    z-index: 0;
  }
}
</style>